export const GAME_TITLE = "CS Connections";
export const MAX_MISTAKES = 4;
